<div class="container">
    <h1 class="text-center">Política de Cookies</h1>

    <p>Bienvenido a nuestra página de Política de Cookies. Aquí, explicaremos qué son las cookies, cómo las usamos en
        nuestro sitio web y cómo puede gestionar sus preferencias respecto a ellas.</p>

    <h2>¿Qué son las cookies?</h2>
    <p>Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita un sitio web. Estos
        archivos permiten que el sitio web reconozca su dispositivo y recuerde cierta información sobre su visita,
        mejorando su experiencia de navegación.</p>

    <h2>¿Qué tipo de cookies utilizamos?</h2>
    <p>En nuestro sitio web, utilizamos únicamente una <strong>cookie necesaria</strong>. Esta cookie es esencial para
        el funcionamiento del sitio y no se puede desactivar en nuestros sistemas. Sin ella, algunas partes del sitio no
        funcionarán correctamente.</p>

    <p><strong>Cookie de Sesión:</strong> Esta cookie se utiliza para gestionar y mantener su sesión activa mientras
        navega por el sitio. Almacena su token de sesión de manera segura, lo que le permite acceder a las áreas
        restringidas del sitio después de iniciar sesión.</p>

    <h2>¿Por qué utilizamos esta cookie?</h2>
    <p>La cookie de sesión es necesaria para:</p>
    <ul>
        <li>Mantener su sesión iniciada mientras navega entre diferentes páginas de nuestro sitio.</li>
        <li>Proteger su cuenta y permitirle acceder a áreas restringidas del sitio.</li>
        <li>Garantizar la seguridad y el buen funcionamiento del sitio web.</li>
    </ul>

    <h2>¿Puedo desactivar esta cookie?</h2>
    <p>Dado que la cookie de sesión es esencial para el funcionamiento del sitio, no puede ser desactivada. Si decide
        bloquearla desde la configuración de su navegador, es posible que no pueda acceder a ciertas partes del sitio o
        que la funcionalidad general del sitio se vea afectada.</p>

    <h2>Gestión de cookies en su navegador</h2>
    <p>Aunque nuestra cookie de sesión es necesaria, puede configurar su navegador para bloquear o alertarle sobre
        cookies en general. Sin embargo, tenga en cuenta que si bloquea nuestra cookie de sesión, es posible que no
        pueda acceder a ciertas partes del sitio.</p>

    <h2>Actualizaciones a esta Política de Cookies</h2>
    <p>Podemos actualizar esta Política de Cookies ocasionalmente para reflejar cambios en nuestras prácticas de uso de
        cookies. Le recomendamos revisar esta política periódicamente para mantenerse informado sobre cómo usamos las
        cookies.</p>

    <h2>Contacto</h2>
    <p>Si tiene alguna pregunta sobre nuestra Política de Cookies, puede ponerse en contacto con nosotros a través de <a
            href="mailto:raqueveque@blister.com.ar">contacto@blister.com.ar</a>.</p>
</div>

<app-back-button routerLink="/login" [backButton]="false" />